module.exports = __webpack_public_path__ + "static/media/close.747f51b6.svg";